import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "I:\\lcy\\\u5DE5\u4F5C\\\u7F51\u7AD9\\\u672A\u5B8C\u6210\\\u4E09\u624D\u91C7\u7F16\\\u793A\u8303\u7AD9\u70B9new\\aliyun\\samsonwebfinal\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.map";
import _defineProperty from "I:\\lcy\\\u5DE5\u4F5C\\\u7F51\u7AD9\\\u672A\u5B8C\u6210\\\u4E09\u624D\u91C7\u7F16\\\u793A\u8303\u7AD9\u70B9new\\aliyun\\samsonwebfinal\\node_modules\\@babel\\runtime-corejs2/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var timeStop;
import md5 from "js-md5";
import CryptoJS from "crypto-js";
import Login_WeiXin from "../../components/Login/Login_WeiXin";
var time;
export default {
  name: "reg",
  data: function data() {
    var _ref;

    return _ref = {
      statuCf: false,
      statuCfa: false,
      showWx: false,
      activeName: "first",
      dialogVisible: false,
      Code: "",
      src: "",
      form: {
        name: "",
        yzcode: "",
        yzcodes: "",
        pass: "",
        rpass: "",
        user: ""
      },
      type: 2,
      types: 0,
      model: "",
      isweixin: false,
      fixmodel: "EmailBox"
    }, _defineProperty(_ref, "dialogVisible", false), _defineProperty(_ref, "loading", true), _defineProperty(_ref, "phoneTiShi", ""), _defineProperty(_ref, "pwdTiShi", ""), _defineProperty(_ref, "rpwdTiShi", ""), _defineProperty(_ref, "EmailTiShi", ""), _defineProperty(_ref, "codeTishi", ""), _defineProperty(_ref, "userTishi", ""), _defineProperty(_ref, "Btn", "发送验证码"), _defineProperty(_ref, "Btn1", "发送邮箱/手机验证码"), _defineProperty(_ref, "wait", 60), _defineProperty(_ref, "user_type", ""), _defineProperty(_ref, "status", 0), _defineProperty(_ref, "GUID", ""), _defineProperty(_ref, "stat", 1), _defineProperty(_ref, "showsuess", false), _defineProperty(_ref, "isphone", false), _defineProperty(_ref, "isphones", false), _defineProperty(_ref, "Picture", ""), _defineProperty(_ref, "Pictures", ""), _defineProperty(_ref, "codeImg", require("../../assets/images/timg.jpg")), _defineProperty(_ref, "GUIDS", ""), _defineProperty(_ref, "codeTiShis", ""), _defineProperty(_ref, "codeshow", true), _defineProperty(_ref, "isEmail", false), _defineProperty(_ref, "iscodeBtn", false), _defineProperty(_ref, "iscodeBtna", true), _defineProperty(_ref, "codess", false), _defineProperty(_ref, "pwdFalseShow", false), _ref;
  },
  components: {
    Login_WeiXin: Login_WeiXin
  },
  created: function created() {
    var _this = this;

    this.initVeri();
    var params = [1000, 1001, 4530, 6018, 6019, 230, 6055, 5000, 5010, 99, 96, 11, 2960, 4553, 6021, 310, 12];
    this.$store.dispatch("_getSet", params).then(function (res) {
      sessionStorage.setItem("SetItem", JSON.stringify(res.data.Data));
      var SetItem = res.data.Data;
      SetItem.map(function (item) {
        if (item.SetItemID == 11) {
          if (item.Item_Value == "是") {
            _this.isphone = true;
          } else {
            _this.isphone = false;
          }
        }

        if (item.SetItemID == 12) {
          if (item.Item_Value == "是") {
            _this.isphones = true;
          } else {
            _this.isphones = false;
          }
        }

        if (item.SetItemID == 2960) {
          if (item.Item_Value == "是") {
            _this.isweixin = true;
          } else {
            _this.isweixin = false;
          }
        }

        if (item.SetItemID == 6021) {
          if (item.Item_Value == "是") {
            _this.isEmail = true;
            _this.activeName = "first";
          } else {
            _this.isEmail = false;
            _this.activeName = "second";
          }
        }

        if (!_this.isphone && !_this.isEmail) {
          _this.activeName = "third";
        }
      });

      if (_this.isEmail) {
        if (_this.isphone) {
          _this.type = 2;
          _this.types = 0;
        } else {
          _this.type = 2;
          _this.types = 0;
        }
      } else {
        if (_this.isphone) {
          _this.type = 3;
          _this.types = 2;
        } else {
          _this.type = 1;
          _this.types = 1;
        }
      }
    }); //   }
  },
  mounted: function () {
    var _mounted = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  methods: {
    wxshow: function () {
      var _wxshow = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var carousel;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.dialogVisible = true;
                _context2.next = 3;
                return this.$store.dispatch("_getGetQrcode");

              case 3:
                carousel = _context2.sent;

                if (carousel) {
                  this.src = carousel.data.Url;
                  this.Code = carousel.data.Code;
                  this.loading = false;
                  this.handleQrcodeCheck(this.type);
                  this.$emit("func", this.src);
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function wxshow() {
        return _wxshow.apply(this, arguments);
      }

      return wxshow;
    }(),
    handleQrcodeCheck: function handleQrcodeCheck(type) {
      var _this2 = this;

      timeStop = window.setInterval(function () {
        _this2.$store.dispatch("_getWeiXinLogin", {
          Scene: _this2.Code
        }).then(function (res) {
          if (res.data.IsSuccess) {
            if (!res.data.Data.IsGo) {
              _this2.pwdFalseShow = true;
              return;
            }

            _this2.$message({
              message: "登录成功",
              type: "success"
            });

            localStorage.setItem("userInfo", JSON.stringify(res.data.Data));
            var urldomain = "/";
            window.location.href = urldomain;

            _this2.$emit("fuab", false);
          }
        });
      }, 2000);
    },
    handleClose: function handleClose(done) {
      done();
      this.dialogVisible = false;
      clearInterval(timeStop);
    },
    //点击QQ登录
    // tz() {
    // 	var urldz = "https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id=101866331&response_type=token&scope=all&redirect_uri=http:/2020test.notefirst.com/login_qq";
    // 	window.location.href = urldz;
    // },
    useqqlogin: function useqqlogin() {
      // this.$router.push("/login_qq")
      // let redirect = "http://2020test.notefirst.com"
      // this.Openkind ="QQ"
      // QC.Login.showPopup({//打开QQ授权登录界面，授权成功后会重定向
      // appId:"101871016",
      // redirectURI:"http://2020test.notefirst.com/#/login_qq",//登录成功后会自动跳往该地址
      // });
      var urldz = "https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id=" + window.OpenId + "&response_type=token&scope=all&redirect_uri=" + window.callBackHtp + "%2F%23%2Flogin_qq";
      window.location.href = urldz;
    },
    handleClick: function handleClick(tab, event) {
      this.codeTiShis = "";
      this.codeshow = true;

      if (this.isEmail) {
        if (this.isphones) {
          if (tab.index == 0) {
            this.type = 2;
            this.types = 0;
            this.model = "EmailBox";
            this.initVeri();
            this.statuCf = false;
            this.statuCfa = false;
          } else if (tab.index == 1) {
            this.type = 3;
            this.types = 2;
            this.model = "Mobile";
            this.initVeri();
            this.statuCf = false;
            this.statuCfa = false;
          } else {
            this.type = 1;
            this.types = 1;
            this.model = "UserName";

            if (this.isEmail) {
              this.initVeri();
            }

            this.statuCf = false;
            this.statuCfa = false;
          }
        } else {
          if (tab.index == 0) {
            this.type = 2;
            this.types = 0;
            this.initVeri();
            this.model = "EmailBox";
            this.statuCf = false;
            this.statuCfa = false;
          } else {
            this.type = 1;
            this.types = 1;
            this.model = "UserName";
            this.statuCf = false;
            this.statuCfa = false;

            if (this.isEmail) {
              this.initVeri();
            }
          }
        }
      } else {
        if (this.isphones) {
          if (tab.index == 0) {
            this.type = 3;
            this.types = 2;
            this.model = "Mobile";
            this.initVeri();
            this.statuCf = false;
            this.statuCfa = false;
          } else if (tab.index == 1) {
            this.type = 1;
            this.types = 1;
            this.model = "UserName";
            this.initVeri();
            this.statuCf = false;
            this.statuCfa = false;
          }
        } else {
          if (tab.index == 0) {
            this.type = 1;
            this.types = 1;
            this.initVeri();
            this.model = "UserName";
            this.statuCf = false;
            this.statuCfa = false;
          }
        }
      }

      this.form = {
        name: "",
        yzcode: "",
        pass: "",
        rpass: "",
        user: ""
      };
      this.phoneTiShi = "";
      this.pwdTiShi = "";
      this.rpwdTiShi = "";
      this.EmailTiShi = "";
      this.codeTishi = "";
      this.userTishi = "";
      this.Btn = "发送验证码";
      this.wait = 60;
      this.user_type = "";
      this.status = 0;
      this.stat = 0;
      this.iscodeBtn = false, this.iscodeBtna = true;
      clearInterval(time);
    },
    getMsgFormSon: function getMsgFormSon(data) {
      this.loading = false;
      this.wx = data;
    },
    dialoga: function dialoga(data) {
      this.dialogVisible = false;
    },
    //鼠标离开
    DetectInput: function DetectInput(elem, type) {
      //焦点离开时候的事件
      if (type == "emails") {
        if (this.$Bai(elem.target.value)) {
          return this.EmailTiShi = "请输入邮箱";
        }

        if (this.$Space(elem.target.value)) {
          return this.EmailTiShi = "邮箱不能含有空格";
        }

        if (!this.$base(elem.target.value, "email")) {
          return this.EmailTiShi = "请输入正确格式的邮箱";
        } else {
          return this.EmailTiShi = "";
        }
      } //   if(type == "codes"){
      // 	  if(this.$Bai(elem.target.value)){
      // 	  return   this.EmailTiShi= "请输入验证码";
      // 	}
      //   }


      if (type == "phone") {
        if (this.$Bai(elem.target.value)) {
          return this.phoneTiShi = "请输入手机号码";
        }

        if (this.$Space(elem.target.value)) {
          return this.phoneTiShi = "手机号不能含有空格";
        }

        if (!this.$base(elem.target.value, "phone")) {
          return this.phoneTiShi = "请输入正确格式的手机号码";
        } else {
          return this.phoneTiShi = "";
        }
      }

      if (type == "pass") {
        if (this.$Bai(elem.target.value)) {
          return this.pwdTiShi = "密码不能为空";
        } else if (elem.target.value.length < 8) {
          return this.pwdTiShi = "密码不能小于八位字符";
        } else if (this.$Space(elem.target.value)) {
          return this.pwdTiShi = "密码不能含有空格";
        } else if (this.$base(elem.target.value, "aff")) {
          return this.pwdTiShi = "密码中含有非法字符";
        } else if (!this.$base(elem.target.value, "pass")) {
          return this.pwdTiShi = "根据国家网络安全法要求，必须使用强密码（密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位）";
        } else {
          this.pwdTiShi = "";
        }
      }

      if (type == "rpwd") {
        if (this.$Bai(elem.target.value)) {
          this.rpwdTiShi = "确认密码不能为空";
        } else if (elem.target.value.length < 8) {
          this.rpwdTiShi = "确认密码不得少于八位字符";
        } else if (this.$Space(elem.target.value)) {
          return this.rpwdTiShi = "密码不能含有空格";
        } else if (this.form.pass != this.form.rpass) {
          this.rpwdTiShi = "两次输入密码不同";
        } else {
          this.rpwdTiShi = "";
        }
      }

      if (type == "user") {
        if (this.$Bai(elem.target.value)) {
          this.userTishi = "账号不能为空";
        } else if (!this.$base(elem.target.value, "name")) {
          this.userTishi = "用户名不符合以上规则";
        } else if (!isNaN(elem.target.value)) {
          this.userTishi = "用户名不符合以上规则";
        } else {
          this.userTishi = "";
        }
      }
    },
    DetectKey: function DetectKey(elem, type) {
      var base = this.base;

      if (type == "phone") {
        this.statuCf = false;
        this.statuCfa = false;
        return this.phoneTiShi = "";
      } else if (type == "code") {
        this.statuCf = false;
        this.statuCfa = false;
        return this.codeTiShi1 = "";
      } else if (type == "pwd") {
        this.statuCf = false;
        this.statuCfa = false;
        return this.pwdTiShi = "";
      } else if (type == "rpwd") {
        this.statuCf = false;
        this.statuCfa = false;
        return this.rpwdTiShi = "";
      } else {
        this.statuCf = false;
        this.statuCfa = false;
        return this.EmailTiShi = "";
      }
    },
    sendCodeBtn: function () {
      var _sendCodeBtn = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3(elem, str) {
        var _this3 = this;

        var Type, name, names, numerr, codes, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("输入"); //点击发送验证码
                //0: Email 1:用户名 2: 手机

                Type = this.types;
                name = "";
                names = "";
                numerr = 0;
                codes = "";
                names = this.form.user;
                codes = this.form.yzcodes;

                if (!(str == "phone")) {
                  _context3.next = 34;
                  break;
                }

                name = this.form.user;
                Type = 1;

                if (!this.$Bai(name)) {
                  _context3.next = 17;
                  break;
                }

                numerr = 1;
                this.stat = 0;
                return _context3.abrupt("return", this.userTishi = "账号不能为空");

              case 17:
                if (this.$base(name, "name")) {
                  _context3.next = 23;
                  break;
                }

                numerr = 1;
                this.stat = 0;
                return _context3.abrupt("return", this.userTishi = "用户名不符合以上规则");

              case 23:
                if (isNaN(name)) {
                  _context3.next = 29;
                  break;
                }

                numerr = 1;
                this.stat = 0;
                return _context3.abrupt("return", this.userTishi = "用户名不符合以上规则");

              case 29:
                this.stat = 1;
                numerr = 0;
                this.userTishi = "";

              case 32:
                _context3.next = 104;
                break;

              case 34:
                name = this.form.name;

                if (!(this.types == 0)) {
                  _context3.next = 78;
                  break;
                }

                if (!(this.type == 1)) {
                  _context3.next = 60;
                  break;
                }

                if (!this.$Bai(names)) {
                  _context3.next = 43;
                  break;
                }

                numerr = 1;
                this.stat = 0;
                return _context3.abrupt("return", this.userTishi = "账号不能为空");

              case 43:
                if (this.$base(names, "name")) {
                  _context3.next = 49;
                  break;
                }

                numerr = 1;
                this.stat = 0;
                return _context3.abrupt("return", this.userTishi = "用户名不符合以上规则");

              case 49:
                if (isNaN(names)) {
                  _context3.next = 55;
                  break;
                }

                numerr = 1;
                this.stat = 0;
                return _context3.abrupt("return", this.userTishi = "用户名不符合以上规则");

              case 55:
                numerr = 0;
                this.stat = 1;
                this.userTishi = "";

              case 58:
                _context3.next = 76;
                break;

              case 60:
                if (!this.isEmail) {
                  _context3.next = 76;
                  break;
                }

                Type = 0;

                if (!(this.type == 2)) {
                  _context3.next = 76;
                  break;
                }

                if (!this.$Bai(name)) {
                  _context3.next = 66;
                  break;
                }

                numerr = 1;
                return _context3.abrupt("return", this.EmailTiShi = "请输入邮箱");

              case 66:
                if (!this.$Space(name)) {
                  _context3.next = 69;
                  break;
                }

                numerr = 1;
                return _context3.abrupt("return", this.EmailTiShi = "邮箱不能含有空格");

              case 69:
                if (this.$base(name, "email")) {
                  _context3.next = 74;
                  break;
                }

                numerr = 1;
                return _context3.abrupt("return", this.EmailTiShi = "请输入正确格式的邮箱");

              case 74:
                numerr = 0;
                this.EmailTiShi = "";

              case 76:
                _context3.next = 93;
                break;

              case 78:
                if (!(this.types == 2)) {
                  _context3.next = 93;
                  break;
                }

                Type = 2;

                if (!this.$Bai(name)) {
                  _context3.next = 83;
                  break;
                }

                numerr = 1;
                return _context3.abrupt("return", this.phoneTiShi = "请输入手机号码");

              case 83:
                if (!this.$Space(name)) {
                  _context3.next = 86;
                  break;
                }

                numerr = 1;
                return _context3.abrupt("return", this.phoneTiShi = "手机号不能含有空格");

              case 86:
                if (this.$base(name, "phone")) {
                  _context3.next = 91;
                  break;
                }

                numerr = 1;
                return _context3.abrupt("return", this.phoneTiShi = "请输入正确格式的手机号码");

              case 91:
                numerr = 0;
                this.phoneTiShi = "";

              case 93:
                if (!(codes == "" || codes == null || codes == undefined)) {
                  _context3.next = 98;
                  break;
                }

                this.codeTiShis = "验证码不能为空";
                return _context3.abrupt("return");

              case 98:
                if (!(codes.length < 6)) {
                  _context3.next = 103;
                  break;
                }

                this.codeTiShis = "请输入正确的验证码";
                return _context3.abrupt("return");

              case 103:
                this.codeTiShis = "";

              case 104:
                if (!(this.wait != 60)) {
                  _context3.next = 106;
                  break;
                }

                return _context3.abrupt("return");

              case 106:
                _context3.next = 108;
                return this.$store.dispatch("_getRegDeteCt", {
                  Account: name,
                  Type: Type
                });

              case 108:
                res = _context3.sent;

                if (!res.data.IsSuccess) {
                  _context3.next = 118;
                  break;
                }

                if (!(res.data.ItemCount == 0)) {
                  _context3.next = 117;
                  break;
                }

                if (!(this.type == 1 && str == "phone")) {
                  _context3.next = 113;
                  break;
                }

                return _context3.abrupt("return", this.stat = 1);

              case 113:
                if (Type == 0) {
                  this.user_type = 1;
                } else {
                  this.user_type = Type;
                }

                this.$store.dispatch("_getRegSendCode", {
                  MobileEmail: name,
                  CRCeMethod: this.user_type,
                  VCode: this.form.yzcodes,
                  Guid: this.GUID
                }).then(function (res) {
                  if (res.data.IsSuccess) {
                    _this3.codeshow = false;
                    _this3.status = 1;
                    _this3.iscodeBtn = true;
                    _this3.iscodeBtna = false;

                    _this3.timeCode(elem.target);

                    _this3.codess = true;
                    localStorage.setItem("forgotStaTime", parseInt(new Date().getTime() / 1000));
                    localStorage.setItem("forgotStaTimeType", _this3.user_type);
                    localStorage.setItem("forgotTemporaryPhoneEmail", _this3.form.name);
                  } else {
                    _this3.initVeri();

                    alert(res.data.Message);
                  }
                });
                _context3.next = 118;
                break;

              case 117:
                if (res.data.ItemCount == 1) {
                  if (str == "phone") {
                    //this.userTishi = "该账号已被人注册。如果您确认该账号是您的账号，可填写验证码后进行密码重置，找回账号。"
                    this.userTishi = "该用户名已被人注册。";
                    this.stat = 0;
                  } else {
                    this.status = 2;
                    this.statuCf = true;
                  }
                } else {
                  if (str == "phone") {
                    this.userTishi = "该手机号已被人注册。如果您确认该手机号是您的手机号，请您找回密码或致电页面底部技术支持";
                    this.stat = 0;
                  } else {
                    this.status = 2;
                    this.statuCfa = true;
                  }
                }

              case 118:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function sendCodeBtn(_x, _x2) {
        return _sendCodeBtn.apply(this, arguments);
      }

      return sendCodeBtn;
    }(),
    timeCode: function timeCode(str) {
      var _this4 = this;

      //验证码时间定时器
      time = setInterval(function () {
        if (_this4.wait == 0) {
          _this4.Btn = "重新发送验证码";
          _this4.wait = 60;
          _this4.codess = false;
          clearInterval(time);
        } else {
          _this4.Btn = "验证码(" + _this4.wait + ")";
          _this4.wait--;
        }
      }, 1000);
    },
    submit: function submit() {
      var _this5 = this;

      //提交
      var status = 0;

      if (this.isEmail) {
        if (this.$Bai(this.form.yzcode)) {
          status = 1;
          this.codeTishi = "验证码不能为空";
        } else if (this.form.yzcode.length != 6) {
          status = 1;
          this.codeTishi = "请输入长度为六位的验证码";
        }
      } else {
        status = 0;
      }

      if (this.$Bai(this.form.yzcodes)) {
        status = 1;
        this.codeTiShis = "验证码不能为空";
      } // else{
      // 	if((this.Pictures).toLowerCase() != (this.form.yzcodes).toLowerCase()){
      // 	status=1;
      //     this.codeTiShis="验证码验证失败"
      // }
      // }


      if (this.$Bai(this.form.pass)) {
        status = 1;
        this.pwdTiShi = "密码不能为空";
      } else if (this.$Space(this.form.pass)) {
        status = 1;
        this.pwdTiShi = "密码不得含有空格";
      } else if (this.$base(this.form.pass, "aff")) {
        status = 1;
        this.pwdTiShi = "密码内含有非法字符";
      } else if (!this.$base(this.form.pass, "pass")) {
        status = 1;
        this.pwdTiShi = "根据国家网络安全法要求，必须使用强密码（密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位）";
      }

      if (this.$Bai(this.form.rpass)) {
        status = 1;
        this.rpwdTiShi = "确认密码不能为空";
      } else if (this.form.rpass.length < 8) {
        this.rpwdTiShi = "确认密码不得少于八位";
      } else if (this.$base(this.form.rpass, "aff")) {
        status = 1;
        this.rpwdTiShi = "确认密码内含有非法字符";
      } else if (this.$Space(this.form.rpass)) {
        status = 1;
        this.rpwdTiShi = "确认密码不得含有空格。";
      } else if (this.form.rpass != this.form.pass) {
        status = 1;
        this.rpwdTiShi = "两次输入的密码不一致";
      }

      if (status == 1) {
        return;
      }

      this.phoneTiShi = "";
      this.pwdTiShi = "";
      this.rpwdTiShi = "";
      this.EmailTiShi = "";
      this.codeTishi = "";
      var pwm = md5(this.form.pass + "!@*Samson*@!");
      var pwaes = CryptoJS.AES.encrypt(this.form.pass, pwm).toString();
      var data = {};

      if (this.type == 1) {
        data = {
          EmailBox: this.form.name,
          UserName: this.form.user,
          Password: pwaes,
          RegisterMethod: this.type,
          TempGuid: this.GUID,
          Code: this.form.yzcode || this.form.yzcodes,
          Pwd: pwm
        };
      } else if (this.type == 2) {
        data = {
          EmailBox: this.form.name,
          Password: pwaes,
          RegisterMethod: this.type,
          TempGuid: this.GUID,
          Code: this.form.yzcode || this.form.yzcodes,
          Pwd: pwm
        };
      } else {
        if (!this.isEmail) {
          data = {
            Mobile: this.form.name,
            UserName: this.form.user,
            Password: pwaes,
            RegisterMethod: this.type,
            TempGuid: this.GUID,
            Code: this.form.yzcode || this.form.yzcodes,
            Pwd: pwm
          };
        } else {
          data = {
            Mobile: this.form.name,
            Password: pwaes,
            RegisterMethod: this.type,
            TempGuid: this.GUID,
            Code: this.form.yzcode || this.form.yzcodes,
            Pwd: pwm
          };
        }
      }

      this.$store.dispatch("_postRegist", data).then(function (res) {
        if (res.data.IsSuccess) {
          sessionStorage.setItem("text", 1);
          alert("注册成功");
          _this5.showsuess = true;
          window.sessionStorage.setItem("Login", 1);

          _this5.$router.push("/Login");
        } else {
          alert(res.data.Message);
        }
      }).catch(function (err) {
        console.log("err", err);
      });
    },
    //页面初始化形成验证码以及GUID
    initVeri: function () {
      var _initVeri = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee4() {
        var random_number, res, i;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                random_number = Math.floor(Math.random() * (100 + 1));
                _context4.next = 3;
                return this.$store.dispatch("_getVerificationcode", {
                  GUID: "",
                  random: random_number
                });

              case 3:
                res = _context4.sent;

                if (res.data.IsSuccess) {
                  this.GUID = res.data.Data.GUID;
                  this.Pictures = res.data.Data.Picture;
                  this.Picture = "";

                  for (i = 0; i < res.data.Data.Picture.split("").length; i++) {
                    this.Picture += '<span style="color:' + this.randomColor() + '">' + res.data.Data.Picture.split("")[i] + "</span>";
                  }
                } else {
                  console.log(res.data.Message);
                }

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function initVeri() {
        return _initVeri.apply(this, arguments);
      }

      return initVeri;
    }(),
    randomColor: function randomColor() {
      var col = "rgb(";

      for (var i = 0; i < 3; i++) {
        col += Math.floor(Math.random() * 256) + ",";
      }

      col = col.slice(0, -1);
      col += ")";
      return col;
    }
  }
};